import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ZwykFooter.css';
import logo from '../assets/zwyk-logo-dark2.svg';
import { ReactComponent as MailIcon } from '../assets/mail-icon.svg';
import { ReactComponent as FacebookIcon } from '../assets/facebook-icon.svg';
import { ReactComponent as InstagramIcon } from '../assets/instagram-icon.svg';

const ZwykFooter: React.FC = () => {
  return (
    <footer className="zwyk-footer">
      <div className="zwyk-footer-content">
        <img width={120} height={'auto'} src={logo} alt="Zwyk Logo"/>
        <h1 className='zwyk-footer-title'>Napisz do nas lub wpadnij na socialki:</h1>
        <div className="zwyk-footer-links">
          <a href="mailto:biuro@zwyk.pl">
            <div className="zwyk-footer-link">
              <div className="zwyk-footer-icon"><MailIcon /></div>
              <p>biuro@zwyk.pl</p>
            </div>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61573584193240" target='_blank'>
            <div className="zwyk-footer-link">
              <div className="zwyk-footer-icon"><FacebookIcon /></div>
              <p>Facebook</p>
            </div>
          </a>
          <a href="https://www.instagram.com/zwykapp?igsh=MXRtdjR0NHppNGc0eQ==" target='_blank'>
            <div className="zwyk-footer-link">
              <div className="zwyk-footer-icon"><InstagramIcon /></div>
              <p>Instagram</p>
            </div>
          </a>
        </div>
        <div style={{marginTop:'30px'}}>
          <Link to="/privacy-policy" className="zwyk-footer-privacy-link">
            Polityka prywatności
          </Link>
        </div>
        <div style={{marginTop:'12px'}}>
          <Link to="/regulamin" className="zwyk-footer-privacy-link">
            Regulamin
          </Link>
        </div>
        <div style={{marginTop:'12px'}}>
          Copyright © Zwyk
        </div>
      </div>
    </footer>
  );
};

export default ZwykFooter; 